export default {
  app: {
    privacy: {
      policy: 'zásady ochrany osobných údajov',
      expansive: 'Používaním Expansive súhlasíte so zásadami {action} Expansive',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'Relácia vypršala',
    sessionExpiredDescription:
      'Vaša relácia vypršala. Prosím, prihláste sa znova, aby ste mohli pokračovať v používaní aplikácie.',
  },
  components: {
    appContainer: {
      chooseLanguage: 'Vyberte jazyk',
      chooseLanguageDescription:
        'Vyberte si preferovaný jazyk pre aplikáciu. Toto zmení jazyk rozhrania a obsahu.',
    },
    userSelection: {
      cancel: 'Zrušiť',
      createNewUser: 'Ich meno nie je uvedené',
      newUser: 'Nový používateľ',
      selectAnExistingUser: 'Vyberte existujúceho používateľa',
      selectUserHint: 'Vyberte existujúceho používateľa alebo vytvorte nového pre pokračovanie.',
      startTypingToSearch: 'Začnite písať...',
    },
    verification: {
      codeVerification: {
        continue: 'Pokračovať',
        header: 'Zadajte prístupový kód na lokalitu',
        invalidCode: 'Neplatný kód, skúste to znova.',
      },
      geoVerification: {
        continueWithoutVerifying: 'Pokračovať bez overenia polohy',
        enterSiteAccessCode: 'Zadajte prístupový kód na lokalitu',
        locationNotEnabledOrAvailable: 'Prečo to vidím?',
        notAvailable: {
          description: 'GPS poloha nie je podporovaná na tomto zariadení.',
          header: 'Poloha nie je podporovaná',
        },
        notEnabled: {
          description: 'Služby polohy nie sú povolené alebo povolenie nebolo udelené.',
          header: 'Poloha nie je povolená',
        },
        notVerified: {
          description: 'GPS naznačuje, že nie ste na mieste.',
          header: 'Poloha neoverená',
        },
        tryAgain: 'Skúsiť znova',
        unavailable: {
          description: 'Nepodarilo sa overiť vašu GPS polohu.',
          header: 'Poloha nedostupná',
        },
        unknown: {
          description: 'Nie je možné určiť vašu polohu.',
          header: 'Neznáma poloha',
        },
        verified: {
          description: 'GPS naznačuje, že ste na mieste.',
          header: 'Poloha overená',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: 'Neboli nájdené žiadne zariadenia',
        emptyDescription: 'K tomuto pracovného príkazu nie sú priradené žiadne zariadenia.',
        warrantyParts: 'Záruka na diely vyprší',
        serialNumber: 'Sériové číslo',
        none: '<žiadne>',
      },
      updates: {
        emptyTitle: 'Neboli nájdené žiadne aktualizácie',
        emptyDescription: 'Pre tento pracovný príkaz nie sú žiadne aktualizácie.',
        unknownUser: 'Neznámy používateľ',
        none: 'Žiadne',
        addComment: {
          buttonLabel: 'Pridať komentár',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: 'Nebezpečenstvá',
          no: 'Nie',
          yes: 'Áno',
        },
      },
    },
    attachmentsList: {
      attachments: 'Prílohy',
      documents: 'Dokumenty',
      siteDocuments: 'Dokumenty lokality',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: 'Nebezpečenstvá',
        induction: 'Zaškolenie',
        safeToProceed: 'Bezpečné pokračovať',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: 'Termín splatnosti',
        activeSessions: 'Aktívne relácie',
        activeSessionsDescription:
          'Už ste prihlásený do nasledujúcich pracovných príkazov. Pred prihlásením do nového pracovného príkazu sa musíte odhlásiť z týchto príkazov.',
        resumeSession: 'Pokračovať',
        startTime: 'Začiatok',
        unexpectedErrorTitle: 'Neočakávaná chyba',
        unexpectedErrorMessage:
          'Pri vytváraní vašich relácií došlo k neočakávanej chybe. Skúste to prosím neskôr.',
        engineerNotFound: 'Inžinier nebol nájdený',
        engineerNotFoundDescription:
          'Inžinier, ktorého sa pokúšate prihlásiť, nebol nájdený v systéme. Kontaktujte svojho administrátora.',
      },
      verification: {
        code: {
          description:
            'Na prihlásenie si vyžiadajte 4-miestny kód od správcu lokality alebo určenej kontaktnej osoby.',
        },
        geo: {
          continue: 'Pokračovať',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              'Pre dokončenie návštevy prosím získajte prístupový kód od vedúceho pracoviska alebo určeného kontaktu.',
            checkOut: 'Odhlásiť sa',
            completeBeforeLeaving: 'Pred odchodom vyplňte nasledujúci formulár.',
            continue: 'Pokračovať',
            noResolutionSelected: 'Pred pokračovaním vyberte riešenie.',
            quoteRequired: {
              hint: 'Návšteva ukončená, ponuka bude nasledovať',
              label: 'Vyžaduje sa ponuka',
            },
            returnVisitRequired: {
              hint: 'Budeme sa musieť vrátiť na dokončenie',
              label: 'Vyžaduje sa opätovná návšteva',
            },
            serviceCompleted: {
              hint: 'Nie sú potrebné ďalšie kroky',
              label: 'Služba dokončená',
            },
            uploadCheckout: 'Nahrajte súbor, fotografiu alebo video',
            visitNotes: 'Poznámky k návšteve',
            workOrderResolution: 'Riešenie pracovného príkazu',
            enterNotes: 'Sem zadajte poznámky...',
            errors: {
              timedOut: 'Čas vypršal, prekročilo sa 30 sekúnd. Skúste to znova.',
              closingSession: 'Chyba pri ukončovaní relácie',
            },
          },
          success: {
            description:
              'Ďakujeme za návštevu {site}. | {site} má ešte 1 otvorený pracovný príkaz. | {site} má ešte {count} otvorených pracovných príkazov.',
            endVisit: 'Ukončiť návštevu',
            header: 'Úspešne ste sa odhlásili',
            viewWorkOrders: 'Prihlásiť sa do ďalšieho pracovného príkazu',
          },
          verification: {
            code: {
              description:
                'Na odhlásenie si vyžiadajte 4-miestny kód od správcu lokality alebo určenej kontaktnej osoby.',
              continue: 'Pokračovať',
            },
            geo: {
              checkOut: 'Odhlásiť sa',
              continue: 'Pokračovať',
            },
          },
        },
        detail: {
          assets: 'Zariadenia',
          call: 'Zavolať',
          checkOut: 'Odhlásiť sa',
          closed: 'Uzatvorené',
          details: 'Podrobnosti',
          dueBy: 'Termín splatnosti',
          manageEngineers: 'Spravovať inžinierov',
          notAvailable: 'Nedostupné',
          pointOfContact: 'Kontaktná osoba',
          siteAccessTimes: 'Časy prístupu na lokalitu',
          siteAccessInstructions: 'Pokyny na prístup',
          siteAddress: 'Adresa lokality',
          siteNotes: 'Poznámky k lokalite',
          siteTelephone: 'Telefón lokality',
          siteLocation: 'Poloha lokality',
          updates: 'Aktualizácie',
          more: 'Viac',
          mismatchErrorTitle: 'Chyba pracovného príkazu',
          mismatchErrorMessage:
            'Pracovný príkaz, ktorý sa pokúšate otvoriť, sa nezhoduje s tým, do ktorého ste aktuálne prihlásený. Skontrolujte svoj pracovný príkaz a skúste to znova.',
          siteDocuments: 'Dokumenty lokality',
          validFrom: 'Platné od',
          validUntil: 'Platné do',
          documentName: 'Názov dokumentu',
          documentType: 'Typ dokumentu',
          attachments: 'Súbory pracovného príkazu',
          download: 'Stiahnuť',
          workDetails: 'Podrobnosti o práci',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: 'Pridať asistenta inžiniera',
            assistantEngineers: 'Asistenti inžinieri',
            description: 'Z bezpečnostných dôvodov uveďte mená všetkých inžinierov na mieste.',
            editMainEngineer: 'Upraviť hlavného inžiniera',
            errors: {
              creatingEngineer: 'Chyba pri vytváraní inžiniera',
              creatingSession: 'Chyba pri vytváraní relácie',
            },
            header: 'Inžinieri na mieste',
            mainEngineer: 'Hlavný inžinier',
            newAssistantEngineer: 'Zadajte ich celé meno',
            next: 'Ďalej',
            removeEngineer: 'Odstrániť inžiniera',
            selectExistingAssistantEngineer: 'Začnite písať ich meno',
          },
          index: {
            description: 'Z bezpečnostných dôvodov uveďte mená všetkých inžinierov na mieste.',
            errorCreatingEngineer: 'Chyba pri vytváraní inžiniera, skúste to znova.',
            header: 'Inžinieri na mieste',
            hintMainEngineer: 'Zadajte celé meno hlavného inžiniera',
            newMainEngineer: 'Nový hlavný inžinier',
            next: 'Ďalej',
            selectExistingMainEngineer: 'Vyberte existujúceho hlavného inžiniera',
            yes: 'Áno',
            no: 'Nie',
            mainEngineerLabel: 'Ste hlavný inžinier?',
          },
        },
        index: {
          callUsOn: 'Zavolajte nám na {phoneNumber}',
          description: 'Neviete nájsť, čo hľadáte?',
          dueBy: 'Termín splatnosti',
          header: 'Vyberte pracovný príkaz',
          notAvailable: 'Nedostupné',
          searchWorkOrders: 'Vyhľadať pracovné príkazy...',
        },
        manageEngineers: {
          manageEngineers: 'Spravovať inžinierov',
          notWorking: 'Neaktívni pracovníci',
          pause: 'Pozastaviť',
          resume: 'Pokračovať',
          workingNow: 'Aktívni pracovníci',
          startTime: 'Čas začiatku',
          endTime: 'Čas ukončenia',
          duration: 'Trvanie',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'Spätná väzba',
            feedbackDescription:
              'Poskytnite spätnú väzbu k pracovného príkazu, aby sme mohli zlepšiť naše služby.',
            feedbackLabel: 'Spätná väzba',
            filesLabel: 'Prílohy',
            submissionLabel: 'Odoslať spätnú väzbu',
          },
          hazards: {
            back: 'Späť',
            hazards: 'Nebezpečenstvá',
            next: 'Ďalej',
            no: 'Nie',
            noTasksForHazard: 'Pre toto nebezpečenstvo nie sú žiadne úlohy.',
            yes: 'Áno',
          },
          induction: {
            continue: 'Pokračovať',
            induction: 'Zaškolenie',
          },
          index: {
            checkIn: 'Prihlásiť sa',
            description: 'Vyplňte nasledujúce hodnotenie rizík pre vybranú prácu.',
            fail: 'Nepodarilo sa spracovať kontroly začiatku práce.',
            haltMessage:
              'Boli zistené potenciálne riziká. Prerušte prácu, preštudujte si bezpečnostné pokyny a kontaktujte svojho nadriadeného.',
            header: 'Kontroly začiatku práce',
            endVisit: 'Ukončiť návštevu',
            leaveFeedback: 'Zanechať spätnú väzbu',
          },
          safeToProceed: {
            continue: 'Pokračovať',
            safeToProceed: 'Bezpečné pokračovať',
          },
        },
      },
    },
    index: {
      title: 'Vitajte',
      description: 'Naskenujte QR kód na vašom mieste pre začiatok.',
    },
    login: {
      errorTitle: 'Neočakávaná chyba',
      errorMessage: 'Vyskytla sa neočakávaná chyba. Skúste znova naskenovať QR kód.',
    },
    unauthenticated: {
      welcome: {
        title: 'Vitajte v {site}',
        description:
          'Predtým, ako vám zobrazíme pracovné príkazy, musíme overiť vaše údaje. Kliknite na tlačidlo nižšie pre pokračovanie.',
        next: 'Pokračovať',
      },
      index: {
        errorTitle: 'Neočakávaná chyba',
        errorMessage: 'Vyskytla sa neočakávaná chyba. Skúste znova naskenovať QR kód.',
      },
      contractor: {
        title: 'Pre koho pracujete?',
        contractor: 'Dodávateľ',
        contractorLabel: 'Začnite písať názov vašej spoločnosti',
        contractorHint: 'Pre zobrazenie výsledkov musíte zadať aspoň 3 znaky',
        defaultSelectPlaceholder: '--Prosím vyberte--',
        next: 'Ďalej',
      },
      user: {
        title: 'Kto ste?',
        cancel: 'Zrušiť',
        createNewUserLabel: 'Moje meno nie je uvedené',
        existingUserLabel: 'Začnite písať svoje meno',
        existingUserHint: 'Pre zobrazenie výsledkov musíte zadať aspoň 3 znaky',
        newUserLabel: 'Zadajte svoje celé meno',
        next: 'Ďalej',
        user: 'Používateľ',
      },
      verification: {
        methods: {
          add: {
            add: 'Pridať spôsob overenia',
            defaultSelectPlaceholder: '--Prosím vyberte--',
            emailLabel: 'Email',
            existingMethodWarning:
              'Už máte čakajúcu žiadosť o tento spôsob overenia, ktorá čaká na schválenie administrátorom. Pridaním nového spôsobu ju prepíšete.',
            method: 'Spôsob',
            methodLabel: 'Spôsob',
            mobileCountryHint: 'Vyberte si kód krajiny',
            mobileCountryLabel: 'Kód krajiny pre mobil',
            mobileHint: 'Zadajte svoje mobilné číslo',
            mobileLabel: 'Mobil',
            title: 'Pridať spôsob overenia',
          },
          confirm: {
            confirm: 'Potvrdiť',
            description: 'Potvrďte svoj spôsob overenia pre pokračovanie.',
            label: 'Zadajte svoj kód',
            resend: 'Znovu odoslať',
            resendPrompt: 'Nedostali ste kód?',
            title: 'Potvrdiť spôsob overenia',
          },
          confirmed: {
            description:
              'Budete informovaní, keď bude tento spôsob overenia schválený administrátorom a potom ho budete môcť použiť na overenie vašej identity.',
            forceApproval: 'Kým nebude schválený, nemôžete pristupovať k pracovným príkazom.',
            nonForceApproval: 'Medzitým môžete pokračovať s obmedzeným prístupom.',
            nonForceApprovalButtonLabel: 'Pokračovať s obmedzeným prístupom',
            title: 'Čaká sa na schválenie',
          },
          addNew: 'Pridať nový spôsob overenia',
          description:
            'Musíme overiť vašu identitu, aby sme vám poskytli plný prístup k pracovnému príkazu.',
          email: 'Email',
          hint: 'Pošleme odkaz na vybraný spôsob overenia, ktorý vám poskytne plný prístup k pracovnému príkazu. Ak potrebujete zmeniť existujúce spôsoby overenia, kontaktujte svojho administrátora.',
          label: 'Vyberte spôsob overenia',
          next: 'Ďalej',
          pendingHint: 'Čaká sa na schválenie administrátorom',
          sms: 'SMS',
          title: 'Overenie',
        },
        optional: {
          hint: 'Overením svojich údajov získate plný prístup k pracovnému príkazu',
          label: 'Chcete overiť svoje údaje?',
          next: 'Ďalej',
          no: 'Nie',
          noHint:
            'Nechcem overiť svoje údaje a pokračovať s obmedzeným prístupom k pracovnému príkazu',
          title: 'Overenie',
          yes: 'Áno',
          yesHint: 'Chcem overiť svoje údaje a získať plný prístup k pracovnému príkazu',
        },
        sent: {
          description:
            'Prihlasovací odkaz bol odoslaný na {identifier}. Kliknite na odkaz pre dokončenie prihlásenia.',
          title: 'Prihlasovací odkaz odoslaný',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: 'Včera',
      today: 'Dnes',
      days: {
        monday: 'Pondelok',
        tuesday: 'Utorok',
        wednesday: 'Streda',
        thursday: 'Štvrtok',
        friday: 'Piatok',
        saturday: 'Sobota',
        sunday: 'Nedeľa',
      },
      months: {
        january: 'Január',
        february: 'Február',
        march: 'Marec',
        april: 'Apríl',
        may: 'Máj',
        june: 'Jún',
        july: 'Júl',
        august: 'August',
        september: 'September',
        october: 'Október',
        november: 'November',
        december: 'December',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: 'Niečo sa pokazilo',
      message: 'Skúste znova naskenovať QR kód.',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: 'Neznámy používateľ',
      },
      none: 'Žiadne',
      types: {
        stateTransition: 'Stav zmenený',
        contractorAssigned: 'Dodávateľ priradený',
        engineerAssigned: 'Inžinier priradený',
        serviceAssigned: 'Služba priradená',
        priorityChanged: 'Priorita zmenená',
        actionableDateChanged: 'Dátum akcie zmenený',
        dueDateChanged: 'Dátum splatnosti zmenený',
        etaDateChanged: 'Odhadovaný čas príchodu zmenený',
        spendLimitApproved: 'Limit výdavkov schválený',
        spendLimitCancelled: 'Žiadosť o limit výdavkov zrušená',
        spendLimitRejected: 'Limit výdavkov zamietnutý',
        spendLimitRequested: 'Žiadosť o limit výdavkov',
        jobSheetUploaded: 'Pracovný list nahraný',
        slaAlertSent: 'Upozornenie na prekročenie SLA',
        issuedWorkPermit: 'Vydané pracovné povolenie',
        requestForServiceSent: 'Odoslaná žiadosť o službu',
        comment: 'Pridaný komentár',
        unknown: 'Neznáma udalosť',
      },
      labels: {
        actionableDate: 'Dátum akcie',
        comment: 'Komentár',
        file: 'Súbor',
        contractor: 'Dodávateľ',
        dueDate: 'Dátum splatnosti',
        etaDate: 'Odhadovaný čas príchodu',
        engineer: 'Inžinier',
        priority: 'Priorita',
        requestForService: 'Žiadosť o službu',
        service: 'Služba',
        spendLimit: 'Limit výdavkov',
        status: 'Stav',
        workPermit: 'Pracovné povolenie',
      },
    },
  },
}
